import { PublicKey } from '@solana/web3.js';

export const DEFAULTS = {
  CLUSTER: 'devnet',
  //todo these need to be PER cluster
  GEM_BANK_PROG_ID: new PublicKey(
    'GPPq4DDXGXrWrQZdBGfMLRvN4u6Z2JoEkBHEZKejvXJi'
  ),
  GEM_FARM_PROG_ID: new PublicKey(
    '4B88kk44XfZ25qSbjHPznPXPcRe37q2u514yrGkRNwQv'
  ),
};
